import script from "./QueueBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueBoard.vue?vue&type=script&setup=true&lang=js"

import "./QueueBoard.vue?vue&type=style&index=0&id=a414a4c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a414a4c2"]])

export default __exports__